import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Check, X, Download } from "lucide-react";
import { Button } from "../components/ui/button";
import { API } from "../config";
import Footer from "./components/Footer";
import { useCart } from "../contexts/AppContext";

export default function CheckoutSuccessPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [downloadLinks, setDownloadLinks] = useState([]);
  const { clearCart } = useCart();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    const pollStatus = async (attempts = 0) => {
      if (attempts >= 5) { setStatus('timeout'); return; }
      try {
        const response = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (response.data.payment_status === 'paid') {
          const completeRes = await axios.post(`${API}/checkout/complete`, null, { params: { session_id: sessionId } }).catch(() => ({}));
          setDownloadLinks(completeRes?.data?.download_links ?? []);
          setStatus('success');
          clearCart();
          return;
        }
        if (response.data.status === 'expired') { setStatus('expired'); return; }
        setTimeout(() => pollStatus(attempts + 1), 2000);
      } catch (error) { setStatus('error'); }
    };
    pollStatus();
  }, [sessionId, clearCart]);

  return (
    <>
    <div className="min-h-screen pt-32 pb-32 px-6 flex items-center justify-center" data-testid="checkout-success-page">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && <div className="animate-fade-in"><div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-6" /><h1 className="text-2xl font-bold font-['Syne'] mb-2">Fizetés feldolgozása</h1><p className="text-muted-foreground">Kérlek várj...</p></div>}
        {status === 'success' && (
          <div className="animate-fade-in text-left">
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6"><Check className="w-10 h-10 text-green-500" /></div>
            <h1 className="text-3xl font-bold font-['Syne'] mb-4 text-center">Köszönjük!</h1>
            <p className="text-muted-foreground mb-6 text-center">Rendelésed megerősítve.</p>
            {downloadLinks.length > 0 && (
              <div className="mb-6 p-4 rounded-xl bg-white/5 border border-white/10">
                <h2 className="text-sm font-semibold mb-3">Digitális tartalom letöltése</h2>
                <p className="text-xs text-muted-foreground mb-3">Mentsd el a linket; később is letöltheted a Fan Club → Vásárolt albumok alatt (ha tag vagy).</p>
                <ul className="space-y-2">
                  {downloadLinks.map((item, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <a href={item.download_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary hover:underline text-sm">
                        <Download className="h-4 w-4 shrink-0" /> {item.product_name} (ZIP)
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="text-center"><Link to="/bolt"><Button className="rounded-full bg-primary hover:bg-primary/90">Vissza a boltba</Button></Link></div>
          </div>
        )}
        {(status === 'error' || status === 'expired' || status === 'timeout') && <div className="animate-fade-in"><div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6"><X className="w-10 h-10 text-red-500" /></div><h1 className="text-3xl font-bold font-['Syne'] mb-4">Hiba történt</h1><p className="text-muted-foreground mb-8">Kérlek próbáld újra.</p><Link to="/bolt"><Button className="rounded-full bg-primary hover:bg-primary/90">Vissza a boltba</Button></Link></div>}
      </div>
    </div>
    <Footer />
    </>
  );
}
